import Lottie from "react-lottie";
import StatsAnim from "../assets/lottie/stats.json";

function StatsCardContent() {
  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: StatsAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      className="flex justify-center flex-col w-full h-full relative"
      style={{ transformStyle: "preserve-3d" }}
    >
      <div
        className="stats-static w-full h-full top-0 absolute left-0 z-20"
        style={{ transformStyle: "preserve-3d" }}
      ></div>
      <div className="stats-anim w-full h-full flex justify-center items-center absolute top-0 left-0 z-10 ">
        <Lottie options={defaultLottieOptions} width="100%" height="auto" />
      </div>
    </div>
  );
}

export default StatsCardContent;
